import { toast } from "react-toastify";
import { erroMensagemExtrair } from "../utils/erroUtilitario";

/**
 * Exibe uma mensagem de erro utilizando o toast
 *
 * @param {Error|Object|string} oErro - O erro a ser exibido
 * @param {string} cMensagemPadrao - Mensagem padrão caso não seja possível extrair do erro
 * @returns {void}
 */
const toastError = (oErro, cMensagemPadrao = "Ocorreu um erro inesperado") => {
  const cMensagem = erroMensagemExtrair(oErro, cMensagemPadrao)

  toast.error(cMensagem, {
    toastId: cMensagem,
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

  return;
};

export default toastError;
